import React from "react";
import { useVerifyUser } from "../../hooks/useVerifyUser";
import AccessDenied from "../layout/AccessDenied";
import DepartmentPage from "../../pages/DepartmentPage";
import uiConfig from "../../config/uiConfig";

const VerifyingAccess = () => (
  <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-gradient-to-br from-[#eef1f8] via-[#f7f8fb] to-[#eef0f6]">
    {/* Decorative background blobs */}
    <div
      aria-hidden="true"
      className="absolute -top-[12%] -left-[8%] h-[320px] w-[320px] animate-verify-blob-float rounded-full bg-[color-mix(in_srgb,var(--app-icon-color,#A70E13)_16%,transparent)] blur-[60px]"
    />
    <div
      aria-hidden="true"
      className="absolute -bottom-[14%] -right-[8%] h-[360px] w-[360px] animate-verify-blob-float-2 rounded-full bg-[color-mix(in_srgb,var(--app-ai-assistant-secondary,#1a2a5e)_16%,transparent)] blur-[70px]"
    />
    <div
      aria-hidden="true"
      className="absolute top-[35%] right-[18%] h-[180px] w-[180px] animate-verify-blob-float-reverse rounded-full bg-[color-mix(in_srgb,var(--app-icon-color,#A70E13)_10%,transparent)] blur-[50px]"
    />

    {/* Glass card */}
    <div className="relative z-10 flex animate-verify-card-fade-in flex-col items-center gap-[22px] rounded-[28px] border border-white/80 bg-white/65 px-14 py-12 shadow-[0_20px_60px_-15px_rgba(30,41,59,0.25)] backdrop-blur-[18px]">
      {/* Rotating gradient ring with logo inside */}
      <div className="relative h-[108px] w-[108px]">
        <div className="absolute inset-0 animate-verify-ring-spin rounded-full bg-[conic-gradient(from_0deg,transparent_0%,var(--app-icon-color,#A70E13)_40%,transparent_55%)]" />
        <div className="absolute inset-0 animate-verify-ring-spin-reverse rounded-full bg-[conic-gradient(from_180deg,transparent_0%,var(--app-ai-assistant-secondary,#1a2a5e)_30%,transparent_45%)] opacity-70" />
        <div className="absolute inset-[6px] flex items-center justify-center rounded-full bg-white shadow-[0_2px_10px_rgba(15,23,42,0.08)]">
          <img
            src={uiConfig.headerLogo}
            alt="Aays"
            className="h-auto w-14 animate-verify-logo-pulse"
          />
        </div>
      </div>

      {/* Text + bouncing dots */}
      <div className="text-center">
        <p className="m-0 flex items-center justify-center gap-2 bg-[linear-gradient(90deg,#334155,var(--app-icon-color,#A70E13),var(--app-ai-assistant-secondary,#1a2a5e),#334155)] bg-[length:200%_auto] bg-clip-text text-[19px] font-bold text-transparent animate-verify-shimmer-text">
          Verifying your access
          <span className="inline-flex gap-[3px]">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="h-[5px] w-[5px] animate-verify-dot-bounce rounded-full bg-[var(--app-icon-color,#A70E13)]"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </span>
        </p>
        <p className="mt-2 mb-0 text-[13px] text-slate-400">
          Please wait while we confirm your permissions
        </p>
      </div>

      {/* Indeterminate progress bar */}
      <div className="h-[5px] w-[220px] overflow-hidden rounded-full bg-slate-400/25">
        <div className="h-full w-[35%] animate-verify-progress-slide rounded-full bg-[var(--app-ai-assistant-gradient,linear-gradient(135deg,#253978,#1a2a5e))]" />
      </div>
    </div>
  </div>
);

const VerifyUsers = () => {
  const { isLoading, isAuth } = useVerifyUser();
  return (
    <div>
      {isLoading && <VerifyingAccess />}

      {!isLoading && isAuth && (
        <>
          <DepartmentPage />
        </>
      )}

      {!isLoading && !isAuth && <AccessDenied />}
    </div>
  );
};

export default VerifyUsers;
